// Предпросмотр сроков в формах главного менеджера. Формулы повторяют сервер
// (adjustTrial / activatePaidPeriod / addPeriod): иначе «продлится до» в форме
// расходилось бы с тем, что запишется.

export function addDays(base: Date, days: number): Date {
  const d = new Date(base);
  d.setDate(d.getDate() + days);
  return d;
}

export function addPeriod(base: Date, period: 'MONTHLY' | 'YEARLY'): Date {
  const d = new Date(base);
  if (period === 'YEARLY') d.setFullYear(d.getFullYear() + 1);
  else d.setMonth(d.getMonth() + 1);
  return d;
}

export function laterOf(a: Date, b: Date | null): Date {
  return b && b.getTime() > a.getTime() ? b : a;
}

/** Значение для <input type="date"> в местном времени. */
export function toDateInputValue(d: Date): string {
  const p = (n: number) => String(n).padStart(2, '0');
  return `${d.getFullYear()}-${p(d.getMonth() + 1)}-${p(d.getDate())}`;
}

/**
 * Конец выбранного дня по местному времени. Полночь UTC показала бы в Москве
 * следующее число, и выбранная дата «уехала» бы на день.
 */
export function endOfLocalDay(value: string): Date | null {
  const m = /^(\d{4})-(\d{2})-(\d{2})$/.exec(value);
  if (!m) return null;
  const d = new Date(Number(m[1]), Number(m[2]) - 1, Number(m[3]), 23, 59, 59);
  return Number.isNaN(d.getTime()) ? null : d;
}
